// extracted by mini-css-extract-plugin
export default {"featureTitle":"Features_featureTitle__gooQP","featureContent":"Features_featureContent__g1Ine"};